'use client';

import { useEffect, useRef } from 'react';

interface RenderAdHtmlProps {
	adHtml: string;
}

export default function RenderAdHtml({ adHtml }: RenderAdHtmlProps) {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const container = containerRef.current;
		if (!container) return;

		// Parse adHtml into a detached DOM
		const parser = new DOMParser();
		const doc = parser.parseFromString(adHtml, 'text/html');

		console.log('doc:', doc);

		// Move <ins>, <div>, etc. into the container
		doc.body.childNodes.forEach((node) => {
			if (node.nodeName !== 'SCRIPT') {
				container.appendChild(node.cloneNode(true));
			}
		});

		// Handle <script> tags
		const scripts = doc.querySelectorAll('script');
		scripts.forEach((script) => {
			const newScript = document.createElement('script');

			// Copy attributes
			for (const attr of script.attributes) {
				newScript.setAttribute(attr.name, attr.value);
			}

			if (script.src) {
				// Check if script already exists
				const alreadyLoaded = Array.from(document.scripts).some((s) => s.src === script.src);
				if (!alreadyLoaded) {
					document.head.appendChild(newScript);
				}
			} else {
				// Inline script, must re-execute
				newScript.textContent = script.textContent;
				container.appendChild(newScript);
			}
		});
	}, [adHtml]);

	console.log('containerRef:', containerRef);
	console.log('containerRef.current:', containerRef?.current);

	return <div ref={containerRef} className="absolute inset-0 size-full object-cover" />;
}
